import { render, staticRenderFns } from "./probationReview.vue?vue&type=template&id=34c4c36c&"
import script from "./probationReview.vue?vue&type=script&lang=js&"
export * from "./probationReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports